module.exports = __webpack_public_path__ + "47e3132ee7567cfffdc8c9a37a67d7c9.png";